export class AccountData {
  public clientCd: string;
  public accountCd: string;
  public accountName: string;
}
